/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Input, Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';

const TitleField = ({ wrapperCol, ...props }) => (
  <Form.ItemWithExtra
    extra={<Link to="#">Menu setup</Link>}
    wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
    {...props}
  >
    <Input placeholder={props.placeholder} />
  </Form.ItemWithExtra>
);

export default TitleField;
